import { FC } from 'react';
import ReactPaginate from 'react-paginate';

import './Pagination.css';

type Props = {
  /** 現在のページ */
  currentPage: number;
  /** 総ページ数 */
  pageCount: number;
  /** ページ変更イベントを処理する関数 */
  handlePageChange: (page: number) => void;
};

export const Pagination: FC<Props> = ({
  currentPage,
  pageCount,
  handlePageChange,
}) => {
  const onPageChange = (selectedItem: { selected: number }) => {
    handlePageChange(selectedItem.selected + 1);
  };

  return (
    <div>
      <ReactPaginate
        forcePage={currentPage - 1} // ライブラリ側は 0 indexed なので -1 する
        pageCount={pageCount}
        onPageChange={onPageChange}
        containerClassName="container"
        pageClassName="page"
        pageLinkClassName="page-link"
        activeClassName="active"
        previousClassName="shift"
        previousLinkClassName="shift-link"
        nextClassName="shift"
        nextLinkClassName="shift-link"
        disabledClassName="shift-disabled"
        disabledLinkClassName="shift-link-disabled"
        nextLabel="次へ"
        previousLabel="前へ"
      />
    </div>
  );
};
